import React from "react"
import CustomMarkdown from "../../utils/customMarkdown"

import "../../scss/components/subheading-text.scss"





const SubheadingText = ({text, subheading, summary, sectionStyle="white", endLine=true}) => {

    const sectionClassName = sectionStyle =="white" ? "white-section" : "dark-section";

    return(
    <section className={sectionClassName + " subheading-text padding-top padding-bottom lateral-padding"}>
        <div className="text-container">
            <CustomMarkdown className='react-markdown-element'>{text}</CustomMarkdown>
            <h2>{subheading}</h2>
            <CustomMarkdown className='react-markdown-element'>{summary}</CustomMarkdown>
            {/* {endLine?<hr/>:""} */}
            
        </div>
    </section>
    )
    
}

export default SubheadingText